import React, { Component, Fragment } from "react";
import {
  bool,
  string,
  func,
  shape,
  number,
  object,
  objectOf,
  any,
  arrayOf
} from "prop-types";
import _ from "lodash";
import moment from 'moment';
import { Grid } from '@material-ui/core';

import dashboardStyles from "./../styles.scss";
import TotalVisitsbyDayofWeek from "../InitialData/TotalVisitsbyDayofWeek.json";
import VeritoneCommonReport from "../VeritoneCommonReport";
import {
  convertCalendarWithTimezone,
  getLatestDate,
  getEarlistDate,
  getChartDataKey,
} from "../../../helpers/formatData";
import { advertiserShape } from "../../../helpers/propTypes";
import { setChartSelector, loadAdperformanceChartDataSaga, changeDateRange } from '../../../state/modules/app/campaign';
import GADataContainer from "../../GADataContainer";
import GAVisitByDayContainer from "components/GAVisitByDayContainer";
import AdsPerformance from "components/AdsPerformance";
import ShowAllAds from "../../Modal/ShowAllAds";
import {
  AD_PERFORMANCE_CHART_ID,
  ADVISIT_BY_DAY_OF_WEEK_CHART_ID,
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  MIN_LENGTH_CUSTOM_WEB_ANALYTICS_TABLE_ROWS,
  MAX_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  GA_CHART_ID,
} from "../../../helpers/constant";
import { DEFAULT_TIME_ZONE_KEY } from 'components/TimeZoneSelector/constants';
import { getNumberOfChartAndTableInReport } from '../Report/helper';
import styles from './styles.scss';

class WebAnalytics extends Component {
  static propTypes = {
    inTabReport: bool,
    onChange: func,
    dateRange: shape({
      startDate: string,
      endDate: string
    }),
    changeDateRange: func,
    showToast: func,
    advertiser: advertiserShape,
    toggleCompare: func,
    inpdf: bool,
    range: string,
    campaign: shape({
      chartData: object,
      campaign_id: number.isRequired
    }),
    setChartSelector: func,
    onAdsPerformanceDateChange: func,
    loadAdperformanceChartDataSaga: func,
    onChangeMasterDatePicker: func,
    onChangeSecondDatePicker: func,
    urlApi: objectOf(string),
    chartData: shape(any),
    numberPage: number,
    page: number,
    endOfTable: number,
    notifications: arrayOf(any),
    areAdSourcesEnabled: bool,
    areAdSourcesEnabledForPdf: bool,
    isCustomReport: bool,
    showInReportConfig: shape({
      webAnalyticsChart: bool,
      timeOfDayChart: bool,
      totalVisitsByAdChart: bool,
      webAnalyticsTable: bool
    }),
    countInReportConfig: shape({
      webAnalyticsChart: arrayOf(number),
      timeOfDayChart: arrayOf(number),
      totalVisitsByAdChart: arrayOf(number),
      webAnalyticsTable: arrayOf(number),
    }),
    setReportChartSelector: func,
    reportChartSelector: objectOf(arrayOf(objectOf(string))),
    tableSortSelector: shape({
        sortKey: string,
        sortType: string,
    }),
    attributeEnabledFlags: arrayOf(string),
    isShouldShowSunsetDisclaimer: bool,
    isHiddenChart: bool,
    isTableOnly: bool,
    rowOnFirstPage: number
  };

  static defaultProps = {
    showInReportConfig: {},
    countInReportConfig: {
      webAnalyticsChart: [1],
      timeOfDayChart: [1],
      totalVisitsByAdChart: [1],
      webAnalyticsTable: [1],
    },
    chartData: {},
    isShouldShowSunsetDisclaimer: false,
  };

  state = {
    openDrillDown: false
  }

  handleCellClick = (data, chartId, timeRange) => {
    const { urlApi, campaign, isCustomReport } = this.props;
    if (isCustomReport) {
      return;
    }
    const { time } = data;

    const detailUrl = {
      urlApi,
      campaignId: campaign.campaign_id,
    }

    switch (timeRange) {
      case 'daily':
        detailUrl.startDate = moment(time, 'MM/DD/YYYY');
        detailUrl.endDate = moment(time, 'MM/DD/YYYY');
        break;
      case 'weekly':
        {
          const timeArr = time.split(/[ -]+/);
          detailUrl.startDate = new Date(timeArr[0]);
          detailUrl.endDate = new Date(timeArr[1]);
          break;
        }
      case 'monthly':
        {
          const {
            start: campaignStart,
            end: campaignEnd
          } = _.get(campaign, 'masterCalendar.selected', {});
          const date = new Date(time);
          const monthStart = moment(date).startOf('month');
          const monthEnd = moment(date).endOf('month');
          detailUrl.startDate = getLatestDate([monthStart, campaignStart]);
          detailUrl.endDate = getEarlistDate([monthEnd, campaignEnd]);
          break;
        }
      case 'hourly':
        {
          detailUrl.hours = time;
          break;
        }
    }

    this.setState({
      chartId,
      openDrillDown: true,
      detailUrl,
      detailInfo: { ...detailUrl }
    });
  }

  handleCloseDrillDown = () => {
    this.setState({
      openDrillDown: false,
      detailInfo: {}
    });
  }

  render() {
    const {
      inTabReport = false,
      onChange,
      dateRange,
      changeDateRange,
      showToast,
      advertiser,
      toggleCompare,
      inpdf,
      campaign,
      range,
      setChartSelector,
      onAdsPerformanceDateChange,
      loadAdperformanceChartDataSaga,
      onChangeMasterDatePicker,
      onChangeSecondDatePicker,
      chartData,
      numberPage,
      page,
      endOfTable,
      notifications,
      areAdSourcesEnabled,
      areAdSourcesEnabledForPdf,
      isCustomReport,
      showInReportConfig,
      countInReportConfig,
      reportChartSelector,
      setReportChartSelector,
      tableSortSelector,
      attributeEnabledFlags,
      isShouldShowSunsetDisclaimer,
      isHiddenChart,
      isTableOnly,
      rowOnFirstPage,
    } = this.props;

    const { openDrillDown, detailUrl, detailInfo, chartId } = this.state;
    const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const secondCalendar = _.get(campaign, "secondCalendar");
    const adPerformanceCalendar = _.get(campaign, "adPerformanceCalendar");
    const selectedSecond = secondCalendar && _.get(secondCalendar, "selected");
    const selectedAdPerformance = adPerformanceCalendar && _.get(adPerformanceCalendar, "selected");
    const rangeSecondCalendar = selectedSecond && convertCalendarWithTimezone(selectedSecond, timezoneKey);
    const rangeAdPerformanceCalendar = selectedAdPerformance && convertCalendarWithTimezone(selectedAdPerformance, timezoneKey);
    const dataWebAnalytics = _.get(chartData, ["1", rangeSecondCalendar, "data"], {});
    const availableAdSources = _.get(campaign, "availableAdSources", []);

    const adPerformanceDataDefault = {
      'dayWithAds': {
        'visit': 0,
        'user': 0
      },
      'dayWithoutAds': {
        'visit': 0,
        'user': 0
      }
    };

    const startCampaign = campaign && campaign.start_date;
    const endCampaign = campaign && campaign.end_date;

    const availableAdSourcesKey = getChartDataKey({
      range: {
        start: startCampaign,
        end: endCampaign,
        timezone: timezoneKey
      }
    });

    const chartDataKey = getChartDataKey({
      selectedAdSources: areAdSourcesEnabled || areAdSourcesEnabledForPdf ? _.get(availableAdSources, [availableAdSourcesKey], []).sort() : null,
      range: {
        start: startCampaign,
        end: endCampaign,
        timezone: timezoneKey
      }
    });

    // AdPerformance chart uses original campaign start & end date
    const chartDataForAdPerfomance = _.get(campaign, ['chartData', chartDataKey], {});
    const adPerformanceData = _.get(chartDataForAdPerfomance, [AD_PERFORMANCE_CHART_ID, rangeAdPerformanceCalendar, "data"], adPerformanceDataDefault);

    const GAVisitByDayData = _.get(chartData, [ADVISIT_BY_DAY_OF_WEEK_CHART_ID, "data"], TotalVisitsbyDayofWeek.data);

    const { webAnalyticsChart, timeOfDayChart, totalVisitsByAdChart, webAnalyticsTable } = showInReportConfig;
    //TODO: revisit those when new report is ready
    const isChartVisible =  !isHiddenChart && (!inpdf || (inpdf && page === 0));
    let showDeleteWebItem = false;
    let showDeleteTimeOfDayChart = false;
    let showDeleteTotalVisitsByAdChart = false;
    let isChartVisibleReport = {
      isWebChartVisible: true,
      isWebTableVisible: true,
      isTimeOfDayChartVisible: true,
      isTotalVisitsByAdChartVisible: true,
    };
    const lastPagePdf = !inpdf || (inpdf && page === numberPage - 1);
    const isGrandTotalDisplay = !inpdf || inpdf && page === endOfTable - 1;
    const isTableDisplay = page < endOfTable;

    if (isCustomReport) {
      isChartVisibleReport = {
        isWebChartVisible: webAnalyticsChart && isChartVisible,
        isWebTableVisible: webAnalyticsTable && (!inpdf || inpdf && isTableDisplay),
        isTimeOfDayChartVisible: timeOfDayChart && lastPagePdf,
        isTotalVisitsByAdChartVisible: totalVisitsByAdChart && lastPagePdf,
      };
      showDeleteWebItem = {
        showDeleteWebAnalyticsChart: webAnalyticsChart,
        showDeleteWebAnalyticsTable: webAnalyticsTable
      };
      showDeleteTimeOfDayChart = timeOfDayChart;
      showDeleteTotalVisitsByAdChart = totalVisitsByAdChart;
    };
    const {
      webAnalyticsChart: webChartCount,
      timeOfDayChart: dayChartCount,
      totalVisitsByAdChart: adChartCount,
      webAnalyticsTable: tableCount,
    } = countInReportConfig;
    const webChartAndTableCount = getNumberOfChartAndTableInReport(webChartCount, tableCount);
    const timeOfDayChartCount = getNumberOfChartAndTableInReport(dayChartCount);
    const totalVisitsByAdChartCount = getNumberOfChartAndTableInReport(adChartCount);
    const webChartSelectors = _.get(reportChartSelector, [GA_CHART_ID], []);
    const timeOfDayChartSelectors = _.get(reportChartSelector, [ADVISIT_BY_DAY_OF_WEEK_CHART_ID], []);
    const totalVisitsByAdChartSelectors = _.get(reportChartSelector, [AD_PERFORMANCE_CHART_ID], []);
    return (
      <div className={dashboardStyles["tabContainer"]}>
        {Array(webChartAndTableCount).fill('').map((_item, index) => {
          const key = webChartCount[index] || tableCount[index] || (index + 1);
          const prefixKey = webChartCount[index] ? 'webChart' : 'webTable';
          const webChartSelector = webChartSelectors[index] || _.get(campaign, ['chartSelector', GA_CHART_ID]);
          const isDisplayChartInPreview = (!!webChartCount.find(item => item === index + 1) && !isHiddenChart || isTableOnly);
          const customShowInReportConfig = {
            isWebChartVisible:  isDisplayChartInPreview && isChartVisibleReport.isWebChartVisible,
            isWebTableVisible: !!tableCount.find(item => item === index + 1) && isChartVisibleReport.isWebTableVisible,
          }
          // calculate number rows of table per page in pdf file
          let tableRowsPerPage = 0;
          if (inpdf) {
            // show table rows on full pdf page and add one more row if this page doesn't display the Grand Total row
            tableRowsPerPage = 25;
            // show fewer rows on the first page because of the chart above the table
            if (page === 0) {
              const numberRowOnFirstPage = rowOnFirstPage || MIN_LENGTH_CUSTOM_WEB_ANALYTICS_TABLE_ROWS;
              tableRowsPerPage = numberRowOnFirstPage + 1;
            }
          }
          return (
            <VeritoneCommonReport
              key={prefixKey + key}
              as={GADataContainer}
              classes={{
                container: dashboardStyles["chart-container"]
              }}
              data={dataWebAnalytics}
              inWebanalyticTab
              onChange={onChange}
              dateRange={dateRange}
              changeDateRange={changeDateRange}
              showToast={showToast}
              advertiser={advertiser}
              toggleCompare={toggleCompare}
              inTabReport={inTabReport}
              campaign={campaign}
              setChartSelector={setChartSelector}
              onChangeMasterDatePicker={onChangeMasterDatePicker}
              onChangeSecondDatePicker={onChangeSecondDatePicker}
              dataWebAnalytics={dataWebAnalytics}
              range={range}
              onCellClick={this.handleCellClick}
              inpdf={inpdf}
              numberPage={numberPage}
              page={page}
              isChartVisible={isChartVisible}
              isCustomReport={isCustomReport}
              isShouldShowSunsetDisclaimer={isShouldShowSunsetDisclaimer}
              isChartVisibleReport={customShowInReportConfig}
              showDeleteWebItem={showDeleteWebItem}
              isTableDisplay={isTableDisplay}
              rowsPerPage={tableRowsPerPage}
              isGrandTotalDisplay={isGrandTotalDisplay}
              displayWebAnalyticsChart={isDisplayChartInPreview}
              itemIndex={index}
              webChartSelector={webChartSelector}
              setReportChartSelector={setReportChartSelector}
              tableSortSelector={tableSortSelector}
              enabledFlags={attributeEnabledFlags}
              rowsFirstPage={rowOnFirstPage}
            />
          )
        })}
        {
          lastPagePdf && (isChartVisibleReport.isTimeOfDayChartVisible || isChartVisibleReport.isTotalVisitsByAdChartVisible) ? (
            <Grid
              className={styles.chartsContainer}
              id='timeOfDayAndTotalVisitChartContainer'
              container
            >
              {Array(timeOfDayChartCount).fill('').map((_item, index) => {
                const isChartVisibleReport = { isTimeOfDayChartVisible: !!dayChartCount[index]};
                const timeOfDayChartSelector = timeOfDayChartSelectors[index] || _.get(campaign, ['chartSelector', ADVISIT_BY_DAY_OF_WEEK_CHART_ID]);
                const key = 'dayChart' + (dayChartCount[index] || (index + 1));
                return (
                  <Fragment key={key}>
                    {dayChartCount[index] ?
                      <Grid
                        xs={isCustomReport? 6 : 5}
                        item
                        classes={{
                          item: styles.headMapContainer
                        }}
                      >
                        <VeritoneCommonReport
                          inpdf={inpdf}
                          inTabReport={inTabReport}
                          as={GAVisitByDayContainer}
                          data={GAVisitByDayData}
                          advertiser={advertiser}
                          title={_.get(chartData, "[2].title", "Time of Day")}
                          campaign={campaign}
                          setChartSelector={setChartSelector}
                          isCustomReport={isCustomReport}
                          isChartVisibleReport={isChartVisibleReport}
                          showDeleteTimeOfDayChart={showDeleteTimeOfDayChart}
                          id={'timeOfDayChart' + index}
                          itemIndex={index}
                          timeOfDayChartSelector={timeOfDayChartSelector}
                          setReportChartSelector={setReportChartSelector}
                          enabledFlags={attributeEnabledFlags}
                        />
                      </Grid>: ''
                    }
                  </Fragment>
                )
              })}
              {Array(totalVisitsByAdChartCount).fill('').map((_item, index) => {
                const isChartVisibleReport = { isTotalVisitsByAdChartVisible: !!adChartCount[index] };
                const totalVisitsByAdChartSelector = totalVisitsByAdChartSelectors[index] || _.get(campaign, ['chartSelector', AD_PERFORMANCE_CHART_ID])
                const key = 'adChart' + (adChartCount[index] || (index + 1));
                return (
                  <Fragment key={key}>
                    {adChartCount[index] ?
                      <Grid
                        xs={isCustomReport ? 6 : 7}
                        item
                        classes={{
                          item: styles.adsPerformanceChartContainer
                        }}
                      >
                        <VeritoneCommonReport
                          inpdf={inpdf}
                          inTabReport={inTabReport}
                          as={AdsPerformance}
                          data={adPerformanceData}
                          campaign={campaign}
                          changeDateRange={changeDateRange}
                          onChange={onChange}
                          showToast={showToast}
                          advertiser={advertiser}
                          onCompareDateChange={onAdsPerformanceDateChange}
                          loadAdperformanceChartDataSaga={loadAdperformanceChartDataSaga}
                          setChartSelector={setChartSelector}
                          areAdSourcesEnabled={areAdSourcesEnabled || areAdSourcesEnabledForPdf}
                          isCustomReport={isCustomReport}
                          isChartVisibleReport={isChartVisibleReport}
                          showDeleteTotalVisitsByAdChart={showDeleteTotalVisitsByAdChart}
                          itemIndex={index}
                          totalVisitsByAdChartSelector={totalVisitsByAdChartSelector}
                          setReportChartSelector={setReportChartSelector}
                          enabledFlags={attributeEnabledFlags}
                        />
                      </Grid> : ''
                    }
                  </Fragment>
                )
              })}
              <ShowAllAds
                id={chartId}
                currentChartId={chartId}
                campaign={campaign}
                detailUrl={detailUrl}
                advertiser={advertiser}
                open={openDrillDown}
                onClose={this.handleCloseDrillDown}
                detailInfo={detailInfo}
                notifications={notifications}
              />
            </Grid>
          ) : ''
        }
      </div>
    );
  }
}

import { connect } from 'react-redux';
import { compose } from 'redux';
import getUrlApi from '../../../helpers/getUrlApi';
import { setReportChartSelector } from '../../../state/modules/app/reportBuilder/actions';

export default connect(
  (state, props) => ({
    urlApi: getUrlApi(state),
    reportChartSelector: props.reportChartSelector || _.get(state, 'reportBuilder.chartSelector', {}),
    areAdSourcesEnabled: _.get(state, 'user.user.organization.kvp.features.attribute.displayAdSourcesFilter') === 'enabled',
    attributeEnabledFlags: props.enabledFlags && props.enabledFlags.length > 0 
      ? props.enabledFlags 
      : Object.keys(
        _.pickBy(
          props.enabledFlags || _.get(state, 'user.user.organization.kvp.features.attribute', {}),
          (value => value === 'enabled')
        )
      )
  }),
  (dispatch, props) => ({
    setChartSelector: compose(dispatch, setChartSelector),
    loadAdperformanceChartDataSaga: props.loadAdperformanceChartDataSaga || compose(dispatch, loadAdperformanceChartDataSaga),
    changeDateRange: props.changeDateRange || compose(dispatch, changeDateRange),
    setReportChartSelector: compose(dispatch, setReportChartSelector),
  })
)
  (WebAnalytics);